import { shine } from '@shinetools/invoicing-calculation'

import { NumberValue } from '../../../utils'
import { DepositInvoiceAmountType } from '../enums/depositInvoiceAmountType'

interface DepositGroup {
  netTotal: number
  vatRate: number
}

interface DepositGroupCalculationResult {
  grossAmount: number
  netAmount: number
}

interface DepositCalculationResult {
  groups: DepositGroupCalculationResult[]
  remainingNetAmount: number
}

interface DepositCalculationOptions {
  baseNetTotal: number
  currency: string
  depositAmount: number
  depositType: DepositInvoiceAmountType
  groups: DepositGroup[]
}

export class InvoiceDepositCalculator {
  static calculate(options: DepositCalculationOptions): DepositCalculationResult {
    const { baseNetTotal, currency, depositAmount, depositType, groups } = options

    const result = shine.Deposit.calculate(
      groups.map((group) => new shine.model.DepositGroupInput(String(group.netTotal), String(group.vatRate))),
      InvoiceDepositCalculator.buildDepositInput(depositAmount, depositType),
      String(baseNetTotal),
      currency,
    )

    return {
      groups: result.groups.map(InvoiceDepositCalculator.mapGroupResult),
      remainingNetAmount: Number(result.remainingNetAmount),
    }
  }

  private static buildDepositInput(
    depositAmount: number,
    depositType: DepositInvoiceAmountType,
  ): shine.model.DepositInput {
    return depositType === DepositInvoiceAmountType.Percentage
      ? shine.Deposit.rate(new NumberValue(depositAmount).divide(100).getStringValue())
      : shine.Deposit.amount(String(depositAmount))
  }

  private static mapGroupResult(result: shine.model.DepositGroupResult): DepositGroupCalculationResult {
    return {
      grossAmount: Number(result.grossAmount),
      netAmount: Number(result.netAmount),
    }
  }
}
